import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import SettingsMenuComponent from '../components/SettingsMenu/SettingsMenuComponent';
import UserSettingsPage from './UserSettingsPage';
import TradeReportPage from './TradeReportPage';
import TradeSettingsPage from 'apex-web/lib/components/Settings/TradeSettings';
import { kycVerificationLevelsSelector } from 'apex-web/lib/redux/selectors/kycLevelsSelectors';
import APIKeysPage from './APIKeysPage';
import UserContactsPage from './UserContactsPage';
import AffiliateProgramPage from './AffiliateProgramPage';
import LoyaltyTokenPage from './LoyaltyTokenPage';
import DemoSettingsContainer from 'apex-web/lib/components/Settings/DemoSettings/DemoSettingsContainer';
import InterestBearingAccountsSettingsContainer from 'apex-web/lib/components/Settings/InterestBearingAccounts/';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import KYCSettings from '../components/KYCSettings';
import { selectIsShowApiKeys } from '../redux/selectors/userConfigSelector';
import './SettingsPage.css';

const settingsPageClasses = getBEMClasses('settings-page');

const SettingsPage = ({ isShowApiKeys }) => {
  return (
    <React.Fragment>
      <div className={settingsPageClasses('container')}>
        <div className={settingsPageClasses('menu')}>
          <SettingsMenuComponent isShowApiKeys={isShowApiKeys} />
        </div>
        <div className={settingsPageClasses('content')}>
          <Route path={'/settings/user'} component={UserSettingsPage} />
          <Route path="/settings/trade" component={TradeSettingsPage} />
          <Route
            path="/settings/iba"
            component={InterestBearingAccountsSettingsContainer}
          />
          <Route path={'/settings/trade-reports'} component={TradeReportPage} />
          {isShowApiKeys && (
            <Route path={'/settings/api-keys'} component={APIKeysPage} />
          )}
          <Route path={'/settings/contacts'} component={UserContactsPage} />
          <Route
            path={'/settings/affiliate'}
            component={AffiliateProgramPage}
          />
          <Route
            path={'/settings/loyalty-token'}
            component={LoyaltyTokenPage}
          />
          <Route
            path={'/settings/verification-level'}
            component={KYCSettings}
          />
          <Route
            path={'/settings/demo-settings'}
            component={DemoSettingsContainer}
          />
        </div>
      </div>
      <div className={settingsPageClasses('footer')}>
        <PageFooterLayout />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  const { verificationLevel } = kycVerificationLevelsSelector(state);
  const isShowApiKeys = selectIsShowApiKeys(state);

  return {
    verificationLevel,
    isShowApiKeys:
      (verificationLevel && Number(verificationLevel) === 99) || isShowApiKeys
  };
};

export default connect(mapStateToProps)(SettingsPage);
